import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import { UploadPreview } from '@ifca-root/react-component/src/components/Avatar/UploadPreview'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { FileUploadInput as DocUploadInput } from '@ifca-root/react-component/src/components/Input/FileUploadInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { changeDateFormat } from '@ifca-root/react-component/src/helpers/Functions/dateFunction'
import useUploadAttachment from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import { ListItem, ListItemText, MenuItem, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { AccountFooter } from 'components/Footer/AccountFooter'
import { TotalAmountFooter } from 'components/Footer/TotalAmountFooter'
import { FormAllocationTableContent } from 'components/Table/FormAllocationTableContent'
import { DropdownTextfield } from 'containers/ARAPModule/Components/DropdownTextField'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  DocumentListingDocument,
  GetApRefundbyStatusDocument,
  RecordStatus,
  useCreateApRefundMutation,
  useDocumentListingLazyQuery,
  useGetApAllocationDocumentLazyQuery,
  useGetBankAccountQuery,
  useGetCreditCardTypeQuery,
  useGetCreditorAccountCompanyAssignmentQuery,
  useGetDocNumTitleQuery,
  useGetPaymentMethodQuery,
  useGetCreatedAccPeriodDateRangeQuery,
  useLatestOpenPeriodCheckingDateQuery,
  useUpdateApRefundMutation,
} from 'generated/graphql'
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import {
  formatDashDate,
  getDatePlusDay,
} from 'helpers/StringNumberFunction/FormatDate'
import { amtNumStr } from 'helpers/StringNumberFunction/NumFormatters'
import { CommonYupValidation } from 'helpers/YupSchema/yup'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import * as yup from 'yup'
import '../APRefund.scss'

interface APRefundProps {
  CompanyID: string
  CreditorAccountID: string
  RefundID: string
  DocDate: Date
  TrxDate: string
  DocAmt: number
  RefNo: string
  Description: string
  Attachment: null
  debitAmt: number
  approval: string
  user: string
  BankAccountID: string
  BankName: string
  PaymentMethodID: string
  CreditCardID: string
  ChequeNo: string
  ChequeDate: Date
  uploadAttach: string
  Allocation: any[]
}
interface FavAPRefundProps {
  Name: string
}

export const APRefundForm = (props: any) => {
  const { formMode, type } = props
  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }

  /* -------------------------------------------- */
  /*               STATE & VARIABLES              */
  /* -------------------------------------------- */
  let history = useHistory()
  let location = useLocation()
  const editData = location?.state as any
  const { CompanyID, RefundID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [openExitDialog, setopenExitDialog] = useState(false)
  const [RefundValidation, setRefundValidation] = useState(false)
  const [valuepicked, setValuePicked] = useState<String>(null)

  // Change Tax descrition into code number
  const [cost, setCost] = useState(amtNumStr(editData?.Amount) ?? 0)
  const [totalAmt, setTotalAmt] = useState(0.0)
  const [amount, setAmount] = useState(0.0)
  const [openExitConf, setOpenExitConf] = useState(null)
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [initDocs, setInitDocs] = useState([])
  const [docAmt, setDocAmt] = useState(0)

  useEffect(() => {
    if (editData?.Attachment) {
      setInitDocs(editData?.Attachment)
    }
  }, [editData])

  const [allocatedObj, setAllocatedObj] = useState({})
  /* -------------------------------------------- */
  /*               QUERY & MUTATION               */
  /* -------------------------------------------- */
  //Creditor Account Company Assignment//
  const {
    loading: CreditorAccountCompanyAssignmentLoading,
    error: CreditorAccountCompanyAssignmentError,
    data: { getCreditorAccountCompanyAssignment } = {
      getCreditorAccountCompanyAssignment: [],
    },
  } = useGetCreditorAccountCompanyAssignmentQuery({
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
    },
  })

  let creditorAcc = getCreditorAccountCompanyAssignment?.map(x => {
    return x?.CreditorAccount
  })

  //PaymentMethod
  const {
    loading: PaymentMethodLoading,
    error: PaymentMethodError,
    data: { getPaymentMethod } = { getPaymentMethod: [] },
  } = useGetPaymentMethodQuery({
    fetchPolicy: 'network-only',
    onCompleted: () => {},
  })

  const {
    called: bankAccountCalled,
    loading: bankAccountLoading,
    data: { getBankAccount } = { getBankAccount: [] },
  } = useGetBankAccountQuery({
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RecordStatus: RecordStatus?.Active,
    },
  })

  const {
    loading: openPeriodCheckDateLoading,
    data: { latestOpenPeriodCheckingDate } = {
      latestOpenPeriodCheckingDate: {} as any,
    },
  } = useLatestOpenPeriodCheckingDateQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
  })

  const {
    data: { getCreatedAccPeriodDateRange } = {
      getCreatedAccPeriodDateRange: {} as any,
    },
  } = useGetCreatedAccPeriodDateRangeQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
  })

  const {
    loading: docNumHeaderLoading,
    error: docNumHeaderError,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RefTable: 'AP_Refund',
    },
  })

  //CreditCardType
  const {
    loading: CreditCardTypeLoading,
    error: CreditCardTypeError,
    data: { getCreditCardType } = { getCreditCardType: [] },
  } = useGetCreditCardTypeQuery({
    fetchPolicy: 'network-only',
    variables: {},
  })

  const [
    createAPRefund,
    {
      loading: createAPRefundLoading,
      called: createAPRefundCalled,
      error: createAPRefundError,
    },
  ] = useCreateApRefundMutation({
    onError: error => {
      console.log('ERROR', error)
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecordFail())
    },
    onCompleted: ({ createAPRefund }) => {
      if (createAPRefund) {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.createNewRecord())
        setTimeout(() => {
          history.push({
            pathname: `/account-payable/${CompanyID}/refund`,
            state: { success: true, msgMode: 'create' },
          })
        }, 500)
      } else {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.createNewRecordFail())
      }
    },
  })

  const [
    updateAPRefund,
    {
      loading: updateAPRefundLoading,
      called: updateAPRefundCalled,
      error: updateAPRefundError,
    },
  ] = useUpdateApRefundMutation({
    onError: error => {
      console.log('ERROR', error)
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecordFail())
    },
    onCompleted: ({ updateAPRefund }) => {
      if (updateAPRefund) {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.updateRecord())
        setTimeout(() => {
          history.push({
            pathname: `/account-payable/${CompanyID}/refund`,
            state: { success: true, msgMode: 'update' },
          })
        }, 500)
      } else {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.updateRecordFail())
      }
    },
  })

  const [
    loadAllocationDocument,
    {
      loading: getAllocationDocumentLoading,
      called: getAllocationDocumentCalled,
      error: getAllocationDocumentError,
      data: { getAllocationDocument } = { getAllocationDocument: [] },
    },
  ] = useGetApAllocationDocumentLazyQuery({
    fetchPolicy: 'network-only',

    onError: error => {
      console.log('ERROR', error)
    },
    onCompleted: ({ getAllocationDocument }) => {
      let arr = []
      if (getAllocationDocument?.length > 0) {
        getAllocationDocument
          .filter(x => x.PaymentID === null || !x?.PaymentID)
          // .filter(
          //   item =>
          //     !getAllocationDocument.some(
          //       ({ PaymentID }) => item.DebitID === PaymentID
          //     )
          // )
          // ?.filter(
          //   alloc =>
          //     Number(alloc?.BalanceAmt) +
          //       Number(allocatedObj[alloc[`${alloc?.CreditOrDebit}ID`]] ?? 0) >
          //       0 && (!alloc?.CanAllocate ? alloc?.AllocationID : true)
          // )
          // ?.sort((x, y) => {
          //   return y?.CanAllocate - x?.CanAllocate
          // })
          ?.map((alloc, index) => {
            arr.push({
              AllocationID: alloc?.AllocationID,
              CreditOrDebit: alloc?.CreditOrDebit,
              DocDate: alloc?.DocDate,
              DocNo: alloc?.DocNo,
              Description: alloc?.Description,
              // for previous allocated amt on the same doc
              AllocationAmt: Number(
                allocatedObj[alloc[`${alloc?.CreditOrDebit}ID`]] ?? 0
              ),
              // balance amount + previous allocated amt on the same doc
              BalanceAmt:
                parseFloat(alloc?.BalanceAmt) +
                Number(allocatedObj[alloc[`${alloc?.CreditOrDebit}ID`]] ?? 0),
              // credit or debit id
              [`${alloc?.CreditOrDebit}ID`]: alloc[`${alloc?.CreditOrDebit}ID`],
              // credit or debit ref table
              [`${alloc?.CreditOrDebit}RefTable`]: alloc[
                `${alloc?.CreditOrDebit}RefTable`
              ],
              // credit or debit doc no
              [`${alloc?.CreditOrDebit}DocNo`]: alloc[
                `${alloc?.CreditOrDebit}DocNo`
              ],
            })

            return alloc
          })
        append(arr)
      }
    },
  })

  /* -------------------------------------------- */
  /*                    USEFORM                   */
  /* -------------------------------------------- */
  const APRefundFormSchema = yup.object().shape({
    DocDate: yup.string().required('Doc Date is required'),
    RefNo: CommonYupValidation.requireField(SystemMsgs.referenceNo()),
    CreditorAccountID: yup.string().required('Creditor Name is required'),
    Description: CommonYupValidation.requireField(SystemMsgs.description()),
    PaymentMethodID: CommonYupValidation.requireField(
      'Refund Method is required'
    ),
    CreditCardID:
      RefundValidation && valuepicked?.includes('Card')
        ? CommonYupValidation.requireField('Credit Card Type is required')
        : null,
    ChequeNo: yup.string().when('PaymentMethodID', {
      is: getPaymentMethod?.find(method => method?.Name === 'Cheque')
        ?.PaymentMethodID,
      then: yup.string().required('Cheque no. is required'),
      otherwise: null,
    }),
    ChequeDate: yup.date().when('PaymentMethodID', {
      is: getPaymentMethod?.find(method => method?.Name === 'Cheque')
        ?.PaymentMethodID,
      then: yup.date().required('Cheque date is required'),
      otherwise: null,
    }),

    BankAccountID: CommonYupValidation.requireField(
      'Bank Account No. is required'
    ),
    Allocation: yup.array().of(
      yup.object().shape({
        AllocationAmt: CommonYupValidation?.requireField(
          'Allocation Amt is required'
        ).nullable(),
      })
    ),
  })

  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    watch,
    getValues,
    clearErrors,
    setError,
  } = useForm<APRefundProps>({
    defaultValues: {
      CompanyID: editData ? editData?.CompanyID : '',
      DocDate: editData ? editData?.DocDate : new Date(),
      RefNo: editData ? editData?.RefNo : '',
      CreditorAccountID: editData ? editData?.CreditorAccountID : '',
      BankAccountID: editData ? editData?.BankAccountID : '',
      PaymentMethodID: editData ? editData?.PaymentMethodID : '',
      CreditCardID: editData ? editData?.CreditCardID : '',
      ChequeNo: editData ? editData?.ChequeNo : '',
      ChequeDate: editData ? editData?.ChequeDate : new Date(),
      DocAmt: editData ? editData?.DocAmt : 0,
      Description: editData ? editData?.Description : '',
      Attachment: editData ? editData?.Attachment : '',
    },
    mode: 'onSubmit',
    resolver: yupResolver(APRefundFormSchema),
  })

  const onSubmit = (data, status) => {
    if (formMode === 'add') {
      createAPRefund({
        variables: {
          input: {
            CompanyID: CompanyID,
            DocDate: formatDashDate(new Date(data?.DocDate)?.toISOString()),
            TransactionDate: formatDashDate(
              new Date(data?.TrxDate)?.toISOString()
            ),
            RefNo: data?.RefNo,
            CreditorAccountID: data?.CreditorAccountID,
            PaymentMethodID: data?.PaymentMethodID,
            CreditCardID: data?.CreditCardID,
            ChequeNo: data?.ChequeNo,
            ChequeDate: data?.ChequeDate,
            ChequeExpiryDate: !!data?.ChequeDate
              ? changeDateFormat(
                  getDatePlusDay(data?.ChequeDate, 180),
                  'DD MMM YYYY'
                )
              : null,
            BankAccountID: data?.BankAccountID,
            Description: data?.Description,
            ApprovalStatus: statusInput(status),
            Amount: parseFloat(getTotalAmt()),
            DocAmt: parseFloat(getTotalAmt()),
            Attachment: files,
          },
          allocationInput: watch('Allocation')
            ?.filter(
              alloc => Number(alloc?.AllocationAmt) !== 0 || alloc?.AllocationID
            )
            ?.map(alloc => {
              const mainCreditOrDebit =
                alloc?.CreditOrDebit === 'Debit' ? 'Credit' : 'Debit'
              return {
                ...(alloc?.AllocationID
                  ? { AllocationID: alloc?.AllocationID }
                  : null),
                AllocationAmt: Number(alloc?.AllocationAmt),
                CreditOrDebit: alloc?.CreditOrDebit,
                CompanyID: CompanyID,
                // for allocated table
                [`${alloc?.CreditOrDebit}RefTable`]: alloc?.[
                  `${alloc?.CreditOrDebit}RefTable`
                ],
                [`${alloc?.CreditOrDebit}ID`]: alloc?.[
                  `${alloc?.CreditOrDebit}ID`
                ],
                // main table
                [`${mainCreditOrDebit}RefTable`]: 'AP_Refund',
              }
            }),
        },
        refetchQueries: [
          {
            query: GetApRefundbyStatusDocument,
            variables: {
              CompanyID: CompanyID,
              StatusArr: ['ACTIVE'],
            },
          },
          {
            query: DocumentListingDocument,
            variables: {
              refTable: 'S_Attachment',
              refID: editData?.RefundID,
            },
          },
        ],
      })
      // }
    } else if (formMode !== 'add') {
      updateAPRefund({
        variables: {
          input: {
            CompanyID: CompanyID,
            RefundID: RefundID,
            DocDate: formatDashDate(new Date(data?.DocDate)?.toISOString()),
            TransactionDate: formatDashDate(
              new Date(data?.TrxDate)?.toISOString()
            ),
            RefNo: data?.RefNo,
            CreditorAccountID: data?.CreditorAccountID,
            PaymentMethodID: data?.PaymentMethodID,
            CreditCardID: data?.CreditCardID,
            ChequeNo: data?.ChequeNo,
            ChequeDate: data?.ChequeDate,
            ChequeExpiryDate: !!data?.ChequeDate
              ? changeDateFormat(
                  getDatePlusDay(data?.ChequeDate, 180),
                  'DD MMM YYYY'
                )
              : null,
            BankAccountID: data?.BankAccountID,
            Description: data?.Description,
            ApprovalStatus: statusInput(status),
            Amount: parseFloat(amtNumStr(data?.Amount)),
            DocAmt: getTotalAmt(),
            Attachment: files,
          },
          allocationInput: watch('Allocation')
            ?.filter(
              alloc => Number(alloc?.AllocationAmt) !== 0 || alloc?.AllocationID
            )
            ?.map(alloc => {
              const mainCreditOrDebit =
                alloc?.CreditOrDebit === 'Debit' ? 'Credit' : 'Debit'
              return {
                ...(alloc?.AllocationID
                  ? { AllocationID: alloc?.AllocationID }
                  : null),
                AllocationAmt: Number(alloc?.AllocationAmt),
                CreditOrDebit: alloc?.CreditOrDebit,
                CompanyID: CompanyID,
                // for allocated table
                [`${alloc?.CreditOrDebit}RefTable`]: alloc?.[
                  `${alloc?.CreditOrDebit}RefTable`
                ],
                [`${alloc?.CreditOrDebit}ID`]: alloc?.[
                  `${alloc?.CreditOrDebit}ID`
                ],
                // main table
                [`${mainCreditOrDebit}RefTable`]: 'AP_Refund',
              }
            }),
        },
        refetchQueries: [
          {
            query: GetApRefundbyStatusDocument,
            variables: {
              CompanyID: CompanyID,
              StatusArr: ['ACTIVE'],
            },
          },
          {
            query: DocumentListingDocument,
            variables: {
              refTable: 'S_Attachment',
              refID: editData?.RefundID,
            },
          },
        ],
      })
    }
  }

  let statusInput = mode => {
    let temp
    switch (mode) {
      case 'submit':
        temp = ApprovalStatus.Submit
        break
      case 'draft':
        temp = ApprovalStatus.Active
        break
      case 'approve':
        temp = ApprovalStatus.Approved
        break
      case 'reject':
        temp = ApprovalStatus.Rejected
        break
    }
    return temp
  }

  const createUpdateLoading = editData
    ? updateAPRefundLoading
    : createAPRefundLoading

  const createUpdateCalled = editData
    ? updateAPRefundCalled
    : createAPRefundCalled

  const { fields, append, remove, prepend } = useFieldArray({
    control,
    name: 'Allocation',
  })

  /* -------------------------------------------- */
  /*                   FUNCTION                   */
  /* -------------------------------------------- */

  const [selectedBank, setSelectedBank] = useState(null)
  // select bank
  const handleBankChange = event => {
    setSelectedBank(
      getBankAccount.find(x => x?.BankAccountID === event?.target?.value)
    )
  }

  const handlePMChange = event => {
    if (
      getPaymentMethod?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name === 'Cheque' ||
      getPaymentMethod
        ?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name?.includes('Card')
    ) {
      setRefundValidation(true)
    } else setRefundValidation(false)
    if (
      getPaymentMethod?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name === 'Cheque'
    ) {
      setValuePicked('Cheque')
    } else if (
      getPaymentMethod
        ?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name?.includes('Card')
    ) {
      setValuePicked('Card')
    } else setValuePicked('')
  }

  //Changing If PM chosed CreditCard
  const [selectedCC, setSelectedCC] = useState(null)
  const creditcard: any = getCreditCardType

  const handleCCChange = event => {
    setSelectedCC(
      creditcard.find(x => x?.CreditCardID === event?.target?.value)
    )
  }

  const handleCreditorDebtorChange = event => {
    remove()
    loadAllocationDocument({
      variables: {
        ...(editData && editData?.CreditorAccountID === event
          ? { entityID: [RefundID] }
          : null),
        creditorDebtorID: event,
        companyID: CompanyID,
        refTable: 'AP_Refund',
      },
    })
  }

  const getTotalAmt = () => {
    if (watch('CreditorAccountID') && watch('Allocation')?.length > 0) {
      return watch('Allocation').reduce((prevValue, currValue) => {
        return prevValue + Number(currValue?.AllocationAmt)
      }, 0)
    } else {
      return 0
    }
  }

  const getTotalBalanceAmt = () => {
    if (watch('CreditorAccountID') && watch('Allocation')?.length > 0) {
      return watch('Allocation').reduce((prevValue, currValue) => {
        return prevValue + Number(currValue?.BalanceAmt)
      }, 0)
    } else {
      return 0
    }
  }

  const checkAlloc = () => {
    if (
      watch('Allocation')?.filter(alloc => Number(alloc?.AllocationAmt))
        ?.length === 0 ||
      watch('DocAmt') > parseFloat(totalAmt.toFixed(2)) ||
      watch('Allocation')?.find(
        alloc =>
          Number(alloc?.AllocationAmt) > parseFloat(totalAmt.toFixed(2)) &&
          parseFloat(totalAmt.toFixed(2)) !== 0
      ) ||
      watch('Allocation') === undefined ||
      docAmt < 0
    ) {
      return true
    } else return false
  }

  /** This is for permission purposes */
  const { handlePermDisabled } = usePermissionChecker()
  /**ACL */

  /* -------------------------------------------- */
  /*                   USEEFFECT                  */
  /* -------------------------------------------- */
  useEffect(() => {
    if (editData?.Allocation) {
      let allocatedArr = editData?.Allocation
      allocatedArr?.map(allocated => {
        if (!(allocated[`${allocated?.CreditOrDebit}ID`] in allocatedObj)) {
          allocatedObj[allocated[`${allocated?.CreditOrDebit}ID`]] =
            allocated?.AllocationAmt
        }
      })
    }
  }, [editData])

  useEffect(() => {
    if (editData?.CreditorAccountID) {
      loadAllocationDocument({
        variables: {
          entityID: RefundID,
          creditorDebtorID: editData?.CreditorAccountID,
          companyID: CompanyID,
          refTable: 'AP_Refund',
        },
      })
    }
  }, [allocatedObj, editData])

  // Edit Bank Account
  useEffect(() => {
    if (!!editData && !!getBankAccount) {
      setSelectedBank(
        getBankAccount?.find(e => e?.BankAccountID === editData?.BankAccountID)
      )
    }
  }, [editData, getBankAccount])

  /* -------------------------------------------- */
  /*                  ATTACHMENT                  */
  /* -------------------------------------------- */
  const {
    files,
    setFiles,
    setPreviewFiles,
    handleUploadChange,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
  } = useUploadAttachment()

  const [
    loadDoc,
    { loading: DocLoad, error: DocError, data: DocData },
  ] = useDocumentListingLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ DocumentListing }) => {
      if (!editData?.files) {
        handleEditUpload(
          DocumentListing?.filter(doc => doc?.description !== 'document_pdf')
        )
        previewFiles?.push(
          ...DocumentListing?.filter(
            doc => doc?.description !== 'document_pdf'
          )?.map(x => x?.fileURL)
        )
      }
    },
  })

  useEffect(() => {
    if (!DocLoad && formMode !== 'add') {
      loadDoc({ variables: { refID: RefundID } })
    }
    if (editData?.files) {
      setFiles(editData?.files)
      setPreviewFiles(
        editData?.files?.map(file => {
          return URL.createObjectURL(file)
        })
      )
    }
  }, [formMode, RefundID, editData])

  const docDateTimestamp = new Date(watch('DocDate'))
  const yearDocDate = docDateTimestamp.getFullYear()
  const monthDocDate = (docDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayDocDate = docDateTimestamp
    .getDate()
    .toString()
    .padStart(2, '0')

  const transferDate = `${yearDocDate}-${monthDocDate}-${dayDocDate}`

  const trxDateTimestamp = new Date(watch('TrxDate'))
  const yearTrxDate = trxDateTimestamp.getFullYear()
  const monthTrxDate = (trxDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayTrxDate = trxDateTimestamp
    .getDate()
    .toString()
    .padStart(2, '0')

  const trxDate = `${yearTrxDate}-${monthTrxDate}-${dayTrxDate}`

  const createdPeriodStartDate = getCreatedAccPeriodDateRange?.StartDate
  const createdPeriodEndDate = getCreatedAccPeriodDateRange?.EndDate
  const hasCreatedPeriodRange =
    !!createdPeriodStartDate && !!createdPeriodEndDate

  const isTrxDateOutsideCreatedPeriodRange =
    hasCreatedPeriodRange &&
    !!trxDate &&
    (trxDate < createdPeriodStartDate || trxDate > createdPeriodEndDate)

  const openPeriod1 =
    transferDate <= latestOpenPeriodCheckingDate?.StartDate ||
    transferDate >= latestOpenPeriodCheckingDate?.EndDate

  const openPeriod2 =
    trxDate >= latestOpenPeriodCheckingDate?.StartDate &&
    trxDate <= latestOpenPeriodCheckingDate?.EndDate

  const checkingYearClose1 = openPeriod1 ? false : true
  const checkingYearClose2 = openPeriod2 ? false : true

  /* -------------------------------------------- */
  /*                    FOOTER                    */
  /* -------------------------------------------- */
  const draftFooterOption = {
    name: 'Save as Draft',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'draft'))()
    },
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled:
      checkingYearClose2 ||
      handlePermDisabled({
        companyID: CompanyID,
        permEnum: AcctPermission.AccPayableRefundDraft,
      }),
  }

  const rejectFooterOption = {
    name: 'Save',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'reject'))()
    },
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled:
      !!errors?.DocDate ||
      !!errors?.TrxDate ||
      !!errors?.RefNo ||
      !!errors?.CreditorAccountID ||
      !!errors?.PaymentMethodID ||
      !!errors?.BankAccountID ||
      !!errors?.Description ||
      checkingYearClose2
        ? true
        : handlePermDisabled({
            companyID: CompanyID,
            permEnum: AcctPermission.AccPayableRefundUpdate,
          }),
  }

  const submitFooterOption = {
    name: 'Submit',
    onClick: e => {
      handleSubmit(data =>
        getDocumentNumberHeader?.filter(x => x?.RefTable === 'AP_Refund')
          ?.length === 0
          ? (setOpenSnackBar(true),
            setSnackBarMsg(SystemMsgs.errorNumberingStructure()))
          : !createUpdateCalled && onSubmit(data, 'submit')
      )()
    },
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled: checkingYearClose2 === true || checkAlloc(),
  }

  let footerOptions: any[]
  if (editData?.mode === 'resubmit') {
    footerOptions = [rejectFooterOption, submitFooterOption]
  } else {
    footerOptions = [draftFooterOption, submitFooterOption]
  }

  /* -------------------------------------------- */
  /*               EXIT CONFIRMATION              */
  /* -------------------------------------------- */
  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: editData,
      formMode: formMode,
      // for attachment
      initFiles: initDocs,
      currFiles: files?.map(file => file?.name),
      // for allocation
      hasAllocation: true,
    })

  return (
    <>
      {createAPRefundLoading && <Loading />}
      {updateAPRefundLoading && <Loading />}
      {CreditorAccountCompanyAssignmentLoading && <Loading />}
      {PaymentMethodLoading && <Loading />}
      {CreditCardTypeLoading && <Loading />}
      {bankAccountLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      {getAllocationDocumentLoading && <Loading />}

      <MainHeader
        mainBtn="close"
        onClick={() => {
          hasChanges() === true
            ? setOpenExitConf(true)
            : history.push(`/account-payable/${CompanyID}/refund`)
          localStorage.removeItem('DebitAmt')
        }}
        smTitle={'Account Payable'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Account Payable' },
          { name: 'AP Submenu' },
          { name: 'Refund Listing' },
          { name: 'Refund', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              mode === 'add'
                ? 'New'
                : mode === 'approve-reject'
                ? 'Approve/Reject'
                : 'Edit',
            current: true,
          },
        ]}
      />

      <ContentWrapper float footer>
        <CardContents>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              required
              as={KeyboardDatePicker}
              name="DocDate"
              label="Date"
              className="left"
              control={control}
              onChange={(date: Date | null) => {}}
              format="dd/MM/yyyy"
              value={watch(formMode === 'add' ? new Date() : editData?.DocDate)}
              margin="dense"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              defaultValue={editData ? editData?.DocDate : new Date()}
              showTodayButton
              disabled={mode == 'approve-reject'}
              style={{
                paddingTop: '10px',
              }}
              // minDate={new Date(latestOpenPeriodCheckingDate?.StartDate)}
              // maxDate={new Date(latestOpenPeriodCheckingDate?.EndDate)}
              // helperText={
              //   checkingYearClose1
              //     ? 'Financial Period already closed'
              //     : errors?.DocDate?.message
              // }
              // error={errors?.DocDate || checkingYearClose1 ? true : false}
            />
          </MuiPickersUtilsProvider>

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="TrxDate"
              required
              label="Transaction Date"
              control={control}
              format="dd/MM/yyyy"
              margin="normal"
              allowKeyboardControl
              onChange={(date: Date | null) => {}}
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              showTodayButton
              className="right"
              value={new Date()}
              defaultValue={editData ? editData?.TransactionDate : new Date()}
              minDate={new Date(latestOpenPeriodCheckingDate?.StartDate)}
              maxDate={new Date(latestOpenPeriodCheckingDate?.EndDate)}
              helperText={
                isTrxDateOutsideCreatedPeriodRange
                  ? 'Accounting period not created'
                  : checkingYearClose2
                  ? 'Financial Period already closed'
                  : errors?.TrxDate?.message
              }
              error={
                errors?.TrxDate ||
                isTrxDateOutsideCreatedPeriodRange ||
                checkingYearClose2
                  ? true
                  : false
              }
            />
          </MuiPickersUtilsProvider>

          <Controller
            as={TextField}
            id="standard-basic"
            name="RefNo"
            label="Reference No."
            required
            autoComplete="off"
            control={control}
            margin="dense"
            ref={register}
            helperText={errors?.RefNo?.message}
            error={errors?.RefNo ? true : false}
            defaultValue={editData ? editData?.RefNo : ''}
            disabled={mode == 'approve-reject'}
          />

          {!CreditorAccountCompanyAssignmentLoading && (
            <Controller
              render={({ value, onChange }) => {
                const defVal = creditorAcc?.filter(
                  x => x?.CreditorAccountID === editData?.CreditorAccountID
                )[0]
                return (
                  <Autocomplete
                    options={
                      creditorAcc?.sort((a, b) => {
                        return a.CompanyName.localeCompare(b.CompanyName)
                      }) || []
                    }
                    getOptionLabel={option => `${option?.CompanyName}`}
                    fullWidth
                    onChange={(value, newValue: any) => {
                      setValue('CreditorAccountID', newValue?.CreditorAccountID)
                      handleCreditorDebtorChange(newValue?.CreditorAccountID)
                    }}
                    renderOption={(props, option) => {
                      return <span>{props?.CompanyName}</span>
                    }}
                    defaultValue={defVal}
                    disabled={mode === 'approve-reject'}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            helperText={errors?.CreditorAccountID?.message}
                            error={errors?.CreditorAccountID ? true : false}
                            label="Creditor Name"
                            style={{ width: '100%' }}
                            margin="dense"
                            required
                          />
                        </div>
                      )
                    }}
                  />
                )
              }}
              label="Creditor Name"
              name="CreditorAccountID"
              autoComplete="off"
              control={control}
              multiline={true}
              fullWidth
              margin="dense"
              ref={register}
              helperText={errors?.CreditorAccountID?.message}
              error={errors?.CreditorAccountID ? true : false}
              defaultValue={editData?.CreditorAccountID}
              required
              disabled={mode === 'approve-reject'}
            />
          )}

          <Controller
            render={({ onChange, value }) => (
              <TextField
                label="Refund Method"
                required
                select
                value={value}
                margin="dense"
                onChange={e => {
                  onChange()
                  handlePMChange(e)
                  setValue('PaymentMethodID', e?.target?.value)
                }}
                defaultValue={editData ? editData?.PaymentMethodID : ''}
                disabled={formMode === 'approve-reject'}
                helperText={errors?.PaymentMethodID?.message}
                error={errors?.PaymentMethodID ? true : false}
              >
                {getPaymentMethod
                  ?.sort((a, b) => {
                    return a.Name.localeCompare(b.Name)
                  })
                  .map((el, index) => (
                    <MenuItem key={index} value={el.PaymentMethodID}>
                      {el.Name}
                    </MenuItem>
                  ))}
              </TextField>
            )}
            control={control}
            helperText={errors?.PaymentMethodID?.message}
            error={errors?.PaymentMethodID ? true : false}
            onChange={e => {
              //handlePMChange(e)
              setValue('PaymentMethodID', e?.target?.value)
            }}
            ref={register()}
            name="PaymentMethodID"
            autoComplete="off"
            value={editData?.PaymentMethodID}
            margin="dense"
            multiline={true}
            fullWidth
            required
          />

          {getPaymentMethod
            .find(el => el.PaymentMethodID === watch('PaymentMethodID'))
            ?.Name?.includes('Card') && (
            <Controller
              render={({ onChange, value }) => (
                <TextField
                  select
                  required
                  name="CreditCardID"
                  margin="dense"
                  label="Card Type"
                  onChange={e => {
                    onChange(e)
                    handleCCChange(e)
                    //setValue('CreditCardID', e?.target?.value)
                  }}
                  defaultValue={editData ? editData?.CreditCardID : ''}
                  disabled={mode == 'approve-reject'}
                  // helperText={errors?.CreditCardID?.message}
                  // error={errors?.CreditCardID ? true : false}
                >
                  {getCreditCardType
                    ?.sort((a, b) => {
                      return a.Name.localeCompare(b.Name)
                    })
                    .map((el, index) => (
                      <MenuItem key={index} value={el.CreditCardID}>
                        {`${el.Name}`}
                      </MenuItem>
                    ))}
                </TextField>
              )}
              label="Card Type"
              name="CreditCardID"
              autoComplete="off"
              control={control}
              // helperText={errors?.CreditCardID?.message}
              // error={errors?.CreditCardID ? true : false}
              multiline={true}
              // defaultValue={getAPRefund[0]?.}
              fullWidth
              margin="dense"
              ref={register}
            />
          )}

          {getPaymentMethod.find(
            el => el.PaymentMethodID === watch('PaymentMethodID')
          )?.Name === 'Cheque' && (
            <>
              <Controller
                as={TextField}
                id="standard-basic"
                name="ChequeNo"
                label="Cheque No"
                className="left"
                required
                autoComplete="off"
                control={control}
                margin="dense"
                ref={register}
                // helperText={errors?.ChequeNo?.message}
                // error={errors?.ChequeNo ? true : false}
                defaultValue={editData ? editData?.ChequeNo : ''}
                disabled={mode == 'approve-reject'}
              />

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Controller
                  required
                  as={KeyboardDatePicker}
                  name="ChequeDate"
                  label="Cheque Date"
                  control={control}
                  onChange={(date: Date | null) => {}}
                  format="dd/MM/yyyy"
                  value={
                    // formMode === 'add' ? new Date() : editData?.ChequeDate
                    watch('ChequeDate')
                  }
                  margin="dense"
                  allowKeyboardControl
                  //inputRef={register({})}
                  ref={register}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  defaultValue={
                    formMode === 'add' ? new Date() : editData?.ChequeDate
                  }
                  showTodayButton
                  className="right"
                  disabled={mode == 'approve-reject'}
                  // helperText={errors?.ChequeDate?.message}
                  // error={errors?.ChequeDate ? true : false}
                />
              </MuiPickersUtilsProvider>
            </>
          )}

          <DropdownTextfield
            // mount={bankNameNeeded}
            disabled={formMode === 'approve-reject' ? true : false}
            helperText={errors?.BankAccountID?.message}
            error={errors?.BankAccountID ? true : false}
            label="Company Bank Account No."
            handleChangeEnabled
            handleChange={handleBankChange}
            selectProps={{
              renderValue: () =>
                `${selectedBank?.AccountNo} (${selectedBank?.BankProfile?.Name})`,
            }}
            customDropdown={getBankAccount?.map((el, index) => (
              <MenuItem
                id="contract-select"
                key={index}
                value={el?.BankAccountID}
              >
                <div className="content-wrap full">
                  <div>
                    <span className="xsTitle">
                      {el.BankProfile?.Name} ({el.BankProfile?.Address?.city})
                    </span>
                  </div>
                  <div className="desc">
                    Account No: {`${el?.AccountNo} (${el?.Code})`}
                  </div>
                </div>
              </MenuItem>
            ))}
            name="BankAccountID"
            control={control}
            register={register}
            // defaultValue={watch(`BankAccountID`)}
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="Description"
            label="Description"
            required
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            helperText={errors?.Description?.message}
            error={errors?.Description ? true : false}
            ref={register}
            defaultValue={
              formMode === 'edit' || mode === 'approve-reject'
                ? editData?.Description
                : ''
            }
            disabled={mode === 'approve-reject'}
            style={{ marginBottom: '44px' }}
          />

          <DocUploadInput
            placeholder={previewFiles.length === 0 ? 'Attachment' : null}
            label={previewFiles.length > 0 ? 'Attachment' : null}
            files={files}
            onHandleUploadChange={handleUploadChange}
            multiple
            accept={
              'application/msword, application/*, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            }
            mapData={'application'}
            imagePreview={
              <>
                {previewFiles?.map((v, i) => (
                  <UploadPreview
                    remove
                    key={v}
                    src={v}
                    onClick={() => removeFile(i)}
                    mediaType={
                      // files[i]?.type
                      files[i]?.type ?? DocData?.DocumentListing[i]?.mediaType
                    }
                  />
                ))}
              </>
            }
            disabled={mode === 'approve-reject'}
          />
        </CardContents>

        {watch('CreditorAccountID') && (
          <FormAllocationTableContent
            fields={fields}
            watch={watch}
            errors={errors}
            register={register}
            control={control}
            setValue={setValue}
            clearErrors={clearErrors}
            setError={setError}
            allocatedObj={allocatedObj}
            totalAmt={getTotalAmt()}
            headerStyle={{
              backgroundColor: '#faf2e8',
              color: '#ff9800',
              fontWeight: '700',
            }}
            hasCheckbox={true}
          />
        )}
      </ContentWrapper>

      {footerOptions?.length > 0 ? (
        <AccountFooter options={[...footerOptions]} />
      ) : null}

      <TotalAmountFooter docAmt={getTotalAmt() ?? 0} />

      <CommonDialog
        fullWidth={true}
        open={openExitDialog}
        onClose={() => setopenExitDialog(false)}
        sections={{
          header: {
            title: 'Exit Confirmation',
          },
          body: () => (
            <>
              <div>
                Are you sure you want to exit? Your changes will not be saved.
              </div>
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => setopenExitDialog(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => history.goBack(),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <CommonDialog
        fullWidth={true}
        open={errorDia}
        onClose={() => setErrorDia(false)}
        sections={{
          header: {
            children: (
              <ListItem className="remove-padding">
                <ListItemText
                  primary={
                    <>
                      <span
                        className="smTitle flex-space"
                        style={{ color: 'red' }}
                      >
                        {'Document Numbering is empty'}
                      </span>
                    </>
                  }
                />
              </ListItem>
            ),
          },
          body: () => (
            <div>
              <span>{'Please setup Document Numbering to Submit'}</span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => setErrorDia(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/account-payable/${CompanyID}/refund`)
        }}
        // hasInfo={hasInfo}
      />
    </>
  )
}

